import { CasesRoute } from '@modules/opportunities/presentation/routes';
import {
  Flex, Input, Box
} from '@huspy/briks-web';
import { Search } from '@huspy/briks-icons';
import { useNavigate } from '@tanstack/react-router';
import { ChangeEvent } from 'react';
import { debounce } from '@shared/utils';
import StatusFilter from '@modules/opportunities/presentation/pages/Cases/List/ControlPanel/components/StatusFilter';
import CreatedByFilter from '@modules/opportunities/presentation/pages/Cases/List/ControlPanel/components/CreatedByFilter';
import { useTranslation } from 'react-i18next';
import FilterButtons from './components/FilterButtons';

const ControlPanel = () => {
  const { q } = CasesRoute.useSearch();

  const navigate = useNavigate({ from: CasesRoute.fullPath });
  const { t } = useTranslation();

  const debouncedSearch = debounce((value: string) => {
    navigate({
      search: (prev) => ({
        ...prev,
        ...(value.length > 0 ? { q: value } : { q: undefined }),
        page: 1,
      }),
    });
  }, 500);

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    debouncedSearch(e.target.value);
  };

  return (
    <Flex justify='start' align='flex-end' w='100%' gap='6'>
      <Box w='221px'>
        <Input
          placeholder={ t('opportunity.caseList.v2.search') }
          bg='bg-secondary'
          borderColor='border-secondary'
          backdropFilter='blur(32px);'
          icon={ <Search width={ 24 } height={ 24 } color='#6B7280' /> }
          iconPosition='left'
          w='100%'
          defaultValue={ q }
          onChange={ handleSearch }
          spellCheck={ false }
          size='md'
          css={ { paddingLeft: '12' } }
          data-test='search-client-input'
        />
      </Box>

      <Flex gap='2'>
        <FilterButtons />
        <CreatedByFilter />
        <StatusFilter />
      </Flex>
    </Flex>
  );
};

export default ControlPanel;
